export default "__VITE_ASSET__uxblcZI7__"